import { TextField } from "@mui/material";

import { isValueless, type StringComparator } from "../FilterSchema";

interface StringValueInputProps {
  comparator: StringComparator;
  value: string[];
  onChange: (next: string[]) => void;
}

export function StringValueInput({
  comparator,
  value,
  onChange,
}: StringValueInputProps) {
  const valueless = isValueless(comparator);

  if (valueless) {
    return null;
  }

  return (
    <TextField
      autoFocus
      size="small"
      fullWidth
      placeholder="Enter value..."
      value={value[0] ?? ""}
      onChange={(event) => {
        onChange([event.target.value]);
      }}
    />
  );
}
